import { Path } from '@openclassrooms/sdk-web';

import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface UseGetParams {
  id: number;
}
interface UseFindParams {
  filters: {
    searchParams: {
      juryRequirement?: 'REQUIRED' | 'NOT_REQUIRED';
      fundingMechanismType?: 'apprenticeship' | 'scholarship';
      'life-cycle-status'?: 'active-or-archived' | 'archived';
      eligibleCountry?:
        | 'FR'
        | 'RE'
        | 'GP'
        | 'MQ'
        | 'PF'
        | 'GF'
        | 'YT'
        | 'NC'
        | 'BL'
        | 'PM'
        | 'WF'
        | 'UK'
        | 'US'
        | 'BE';
    };
  };
}
const { useGet: usePath, useFind: usePaths } = getCRUDHooks<Path, UseGetParams, UseFindParams>({
  entityName: 'paths',
});

export { usePath, usePaths };
